import React from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import styles from './FilterRow.module.scss';

interface FilterRowProps {
    label: string;
    enabled: boolean;
    onToggle: () => void;
    children?: React.ReactNode;
}

export const FilterRow: React.FC<FilterRowProps> = ({ label, enabled, onToggle, children }) => (
    <div className={styles.row}>
        <div className={styles.label}>
            <Switch
                checked={enabled}
                onChange={onToggle}
            />
            <span>{label}</span>
        </div>
        {enabled && children && <div className={styles.dependentRow}>{children}</div>}
    </div>
);
